import React  from 'react';
import {
  Card, 
  CardBody,CardHeader ,
  Row, Col, Table,
 } from "reactstrap";
import { Spinner } from 'components/Icons/Spinner';


// let MP_pk = 'APP_USR-37851fda-c48c-45ff-a903-c947a01dfda9';
// let MP_at = 'APP_USR-2291605996312131-112021-97ac5d8ca1d0820bee9dd34bd2d4a50f__LC_LD__-115024';
var sdf = require('date-format');



// let MP_pk = 'TEST-26673ba4-a9e8-40e4-b60d-05cb3090d957';
// let MP_at = 'TEST-2291605996312131-112021-4fd21a26c3ae0fb07cedccae2a246896__LC_LB__-115024';

// let MP_cl = '2291605996312131';
// let MP_cs = 'nxsJizQZ7Asqp0umAZ1nzSO02hJb2N3F';


// const doPayment = () => {
    
//       const mp = new MercadoPago(MP_pk, {
//         locale: 'es-AR'
//         });

//         // Inicializa el checkout
//         mp.checkout({
//             preference: {
//                 id: 'YOUR_PREFERENCE_ID'
//             },
//             render: {
//                     container: '.cho-container', // Indica dónde se mostrará el botón de pago
//                     label: 'Pagar', // Cambia el texto del botón de pago (opcional)
//             }
//         });
// }

  

   const StudentDebt = ( { invoices  } ) =>  {
        return (
          
          <>
          
          {invoices ?
          
              <Card >
                  <CardHeader>
                    Actualmente nos figuran impagas las siguientes facturas
                  </CardHeader>
                <CardBody>
                  <Row>
                      <Col sm="12">
                      <Table responsive bordered striped size="sm">
                            <thead>
                                <tr>
                                    <th>Factura</th>
                                    <th>Fecha</th>
                                    <th>Descripción</th>
                                    <th>Monto</th>
                                    <th>Cargos</th>
                                    <th>Total</th>
                                    <th>Vencimiento</th>
                                    <th></th>
                                </tr>
                            </thead>
                        <tbody>
                            { invoices.map( ( invoice, idx ) => { 
                            return (
                                <>
                                <tr key={invoice.invoice_id}>
                                    
                                    <td>{sdf('dd/MM/yyyy', new Date(invoice.invoice_dt.replace('Z','')))}</td>
                                    <td>{invoice.ref_id}</td>
                                    <td>{invoice.description}</td>
                                    <td align="right">{invoice.amount}</td>
                                    <td align="right">{invoice.charges}</td>
                                    <td align="right">{(parseFloat(invoice.amount) + parseFloat(invoice.charges)).toFixed(2) }</td>
                                    <td>{sdf('dd/MM/yyyy', new Date(invoice.due_dt.replace('Z','')))}</td>
                                    {/* <td><div id='cho-container'></div>
                                    <Button color="default" size="sm"
                                        onClick={() => doPayment( invoice )} 
                                        >
                                        Pagar
                                    </Button>
                                    </td> */}
                                </tr>
                                </> 
                                )
                            } ) }
                        </tbody>
                      </Table>
                      </Col>
                  </Row>
                </CardBody>
              </Card>
          :
          <Spinner size="XL" />
          }
        </>
  
        );
        }

export { StudentDebt } ;
